<template>
  <AppCard class="h-full" :top-padding="topPadding" :bottom-padding="bottomPadding">
    <!-- Header -->
    <template #header>
      <div class="flex justify-between">
        <div>Preview & Share</div>
        <!--
        <button @click="emit('cancel')" class="flex items-center gap-2"><icon-mdi-window-close />Cancel</button>
        -->
      </div>
    </template>

    <!-- Main content -->
    <template #default>
      <img v-if="image" :src="image" alt="Cropped composite" class="w-full h-full object-contain" />
    </template>

    <!-- Footer -->
    <template #footer>
      <div class="flex justify-center">
        <div class="flex flex-wrap content-center gap-1.5">
          <app-btn class="" @click="emit('crop')">
            Edit
          </app-btn>

          <app-btn class="" @click="downloadImage">
            Download
          </app-btn>

          <app-btn v-if="isSupported" class="square primary" @click="shareImage">
            Share
          </app-btn>
          <app-btn @click="emit('cancel')">Cancel</app-btn>
        </div>
      </div>
    </template>
  </AppCard>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'
import { useShare } from '@vueuse/core'
import { trackEventKey, marathonNameKey } from '@/composables/useAnalytics'
import type { TrackEventFn } from '@/composables/useAnalytics'
import AppCard from './AppCard.vue';

const props = withDefaults(defineProps<{
  image: string | null  // expect the composited image as a data URL
  fileName: string
  bottomPadding?: number
  topPadding?: number
}>(), {
  defaultAspect: 4 / 5,
  topPadding: 0,
  bottomPadding: 0
})

const emit = defineEmits(['cancel', 'crop'])

const { share, isSupported } = useShare()
const error = ref('')
const trackEvent = inject<TrackEventFn>(trackEventKey, () => {})
const marathonName = inject(marathonNameKey, '')

async function shareImage() {
  if (!(isSupported.value && props.image)) return

  try {
    const response = await fetch(props.image)
    const blob = await response.blob()
    const file = new File([blob], props.fileName, { type: blob.type })

    await share({
      title: 'My Race Image',
      text: "I've collected another Abbott World Marathon Majors Star. Check it out!",
      files: [file],
    })
    trackEvent('wmm_image_shared', { event_category: 'wmm_share_widget', marathon_name: marathonName })
  } catch (err) {
    console.error('Error sharing:', err)
    error.value = err instanceof Error ? err.message : String(err)
  }
}

function downloadImage() {
  if (!props.image) return
  trackEvent('wmm_image_downloaded', { event_category: 'wmm_share_widget', marathon_name: marathonName })
  const a = document.createElement('a')
  a.href = props.image
  a.download = props.fileName
  a.click()
}
</script>
